export class SystemLogsController {

    constructor($window, $scope, JFrogEventBus, User, TOOLTIPS, $timeout, LogsDao) {
        this.LOG_LEVELS = [
            {displayName: 'FINE', val: 'FINE', icon: 'icon-view'},
            {displayName: 'DEBUG', val: 'DEBUG', icon: 'icon-download', disabled: true},
            {displayName: 'INFO', val: 'INFO', icon: 'icon-go'},
            {displayName: 'WARN', val: 'WARN', icon: 'icon-clear'},
            {displayName: 'ERR ', val: 'ERROR', icon: 'icon-clear'}
        ];
        this.generalLogLevel = "ERROR"
        this.$timeout = $timeout;
        this.user = User;
        this.LogsDao = LogsDao;
        this.$scope = $scope;
        this.$window = $window;
        this.logParams = {start: true, analysis: true, persist: true, indexer: true, server: true};
        this.logs = [];
        this.logsDao = LogsDao;
        let EVENTS = JFrogEventBus.getEventsDefinition();
        let removeListener = JFrogEventBus.register(EVENTS.UPDATE_LOG_DATA, (data) => this._transformDataForLogs(data.Data.log_entries));
        this.showScroll = false;
        this.logs = [];
        $scope.$on('$destroy', () => {
            removeListener();
            this._closeConnection();
        })
        /*this.$window.onbeforeunload = (event) => {
            this._closeConnection();
        };
         */

        this.getLogsLevel();
        this.autoScroll = true;
        this._scrollToBottom();
        this.autoRefresh = true;
        this.configMode = true;

        this.$timeout(() => {
            this._setScrollbtn();
        })


        this.$timeout(() => {
            //this._closeConnection();
            this.logParams.start = true;
            this.getLogs();
        }, 500)
    }

    _closeConnection() {
        this.logParams.start = false;
        this.getLogs();
    }

    _setScrollbtn() {
        $('#card').scroll(() => {
            var div = $('#card');
            if (div[0].scrollHeight - div.scrollTop() == div.height() + 30) {
                this.showScroll = false;
            }
            else {
                this.showScroll = true;
            }
            this.$scope.$apply();
        });

    }

    getLogs() {
        this.LogsDao.getLogs(this.logParams).$promise.then((data) => {
        });

    }

    _scrollToBottom() {
        this.$timeout(() => {
            $("#card").animate({scrollTop: $('#card').prop("scrollHeight")}, 1000);
        }, 0);
    }

    _transformDataForLogs(data) {
        let logs = [];
        if (data) {
            _.each(data, (val, key) => {
                let tmpObj = {};
                tmpObj.type = val.LogName.toLowerCase().replace('[', '').replace(']', '');
                tmpObj.msg = val.LogMsg;
                logs.push(tmpObj);
                if (tmpObj)
                    this.logs.push(tmpObj);
            });

            if (this.logs.length > 1000)
                this.logs.splice(0, 500);

            if (this.autoScroll)
                this._scrollToBottom();

        }
    }

    filterLogs() {

        this.getLogs();

    }

    toggleAction(type) {

        if (type === 'refresh') {

            this.autoRefresh === true ? this.autoRefresh = false : this.autoRefresh = true;

            if (this.autoRefresh) {
                this.logParams.start = true;
                this.getLogs();
            } else {
                this.logParams.start = false;
                this.getLogs();
            }
        }

        if (type === 'config') {

            this.configMode === true ? this.configMode = false : this.configMode = true;
        }
        if (type === 'scroll') {

            this.autoScroll === true ? this.autoScroll = false : this.autoScroll = true;
        }

    }

    downloadLog() {
        let token = this.user["XRayUIState"].states.sessionData.token;
	    this.$window.open('/ui/logs/download?token=' + token, '_self');
    }

    clearLog() {
        this.logs = [];
    }

    getLogsLevel(msName = 'all') {
        if (this.servicesLevel) {
            if (this.servicesLevel.all) {
                this.lastAllLevel = this.servicesLevel.all;
            }

        }
        this.LogsDao.getServiceLevel({msName}).$promise.then((data) => {
            this.servicesLevel = _.mapKeys(data.ms_log_configs, 'ms_name');
            this.servicesLevel.all = {};
            this.GeneralLogSliderStatus = this.allValsEquals(_.map(data.ms_log_configs, 'level'));
            this.servicesLevel.all.level = this.GeneralLogSliderStatus.level
            if (this.lastAllLevel) {
                this.servicesLevel.all = this.lastAllLevel;
            }
            this.sliderOptObj = {};
            this.sliderOptObj.server = this.getOptions('server');
            this.sliderOptObj.indexer = this.getOptions('indexer');
            this.sliderOptObj.persist = this.getOptions('persist');
            this.sliderOptObj.analysis = this.getOptions('analysis');
            this.sliderOptObj.general = this.getOptions('all');
            this.ServerOptions = this.getOptions('server');
            this.rerenderSlider();
            this.$timeout(() => {
                this.GeneralLogSliderStatus = this.allValsEquals(_.map(this.servicesLevel, 'level'));
            });
        });
    }

    setLogsLevel(msName = 'all', level = 'info') {
        this.LogsDao.setServiceLevel({msName, level}, {}).$promise.then((data) => {
            if (msName === 'all') {
                this.$timeout(() => {
                    this.getLogsLevel();
                }, 1000);
            }

        });

    }

    logChanged(service) {
        this.setLogsLevel(service, this.servicesLevel[service].level);
        this.GeneralLogSliderStatus = this.allValsEquals(_.map(this.servicesLevel, 'level'));
        this.$scope.$broadcast('rzSliderForceRender');
    }

    rerenderSlider() {
        /*if (this.GeneralLogSliderStatus.isEqual) {
         this.servicesLevel.all.level = this.GeneralLogSliderStatus.level;
         }*/
        this.$timeout(() => {
            this.$scope.$broadcast('rzSliderForceRender');
        });

    }

    getOptions(serviceName) {
        let obj = {
            options: {
                id: serviceName,

                showTicks: true,
                showSelectionBar: true,
                getPointerColor: (value) => {
                    if (value <= 3)
                        return 'red';
                    if (value <= 6)
                        return 'orange';
                    if (value <= 9)
                        return 'yellow';
                    return '#2AE02A';
                },
                getSelectionBarColor: function (value) {
                    if (value === 'ERROR')
                        return '#939393';
                    if (value === 'WARN')
                        return '#7e7e7e';
                    if (value === 'INFO')
                        return '#696969';
                    if (value === 'DEBUG')
                        return '#545454';
                    if (value === 'FINE')
                        return '#3f3f3f';
                    return '#2AE02A';
                },
                selectionBarGradient: {
                    from: 'yellow',
                    to: '#FC0'
                },
                onEnd: (id) => {

                    this.logChanged(id)
                },
                stepsArray: [
                    {value: 'ERROR'},
                    {value: 'WARN'},
                    {value: 'INFO'},
                    {value: 'DEBUG'},
                    {value: 'FINE'}
                ]
            }
        }
        if (serviceName !== 'all')
            obj.value = this.servicesLevel[serviceName].level;
        return obj;
    }

    allValsEquals(arr) {

        if (arr.length > 5) {
            arr.splice(5, 1);
        }

        for (var i = 1; i < arr.length; i++) {
            if (arr[i] !== arr[0])
                return {isEqual: false, level: 'ERROR'};
        }
        return {isEqual: true, level: arr[0]};
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/system_logs/system_logs.controller.js